import { rem } from 'polished'
import { css } from 'styled-components'
import { listingWideLayoutQuery } from '../ExperienceListingDrawer/constants'

/** Clamped rather than a bare percentage, because this drawer renders in a resizable panel. */
export const thingsToDoPlaceTileLayout = css`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${props => props.theme.borderRadius.S};
  overflow: hidden;

  ${listingWideLayoutQuery} {
    grid-template-columns: clamp(${rem(260)}, 50%, ${rem(540)}) minmax(0, 1fr);
    align-items: stretch;
  }
`

export const thingsToDoPlaceTileImage = css`
  position: relative;
  aspect-ratio: 2 / 1;
  overflow: hidden;

  /* Google returns a place with no photo of any kind rarely but not never, and the box still has to
     hold the Add to trip button, so it keeps its size and reads as deliberate rather than broken. */
  &.has-no-image {
    background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  }
  /* Takes the width from its column, which the aspect ratio would otherwise decide: stretched
     beside taller content the height is definite, and 2:1 turns that into a width wider than the
     column. The ratio still shapes the stacked layout, where the height is free. */
  width: 100%;
`

// Tighter than the drawer's other tiles: content outgrowing the image's 2:1 height stretches it.
export const THINGS_TO_DO_TILE_CONTENT_PADDING = 16
export const THINGS_TO_DO_TILE_CONTENT_GAP = 8
export const THINGS_TO_DO_DESCRIPTION_LINE_CLAMP = 3
